<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9 3a1 1 0 00-2 0h2zM8 13l-.707.707a1 1 0 001.414 0L8 13zm3.707-2.293a1 1 0 00-1.414-1.414l1.414 1.414zm-6-1.414a1 1 0 00-1.414 1.414l1.414-1.414zM7 3v10h2V3H7zm1.707 10.707l3-3-1.414-1.414-3 3 1.414 1.414zm0-1.414l-3-3-1.414 1.414 3 3 1.414-1.414z"/></svg>